import React from 'react'
import Traduction from 'Components/Traduction'
import Select from 'Components/Select'
import Constants from 'EurestoFonction/Constants'
import DataComponent from '../../../DataComponents/index'
import Grid from '@material-ui/core/Grid'
import ApiRequest from 'EurestoApi/ApiRequest'
import defaultAvatar from 'EurestoStyle/font/stripes-light.png'
import EurestoForm from 'Components/Form'
import Utils from 'EurestoFonction/Utils'


const project = require('EurestoConfig/project.config')

export default class extends React.Component {
  constructor (props) {
    super(props)
    const newState = {
      ...props,
      action: props.action,
      key: Utils.getRandomNumber()
    }
    this.state = {
      saveState: { ...EurestoClone(newState) },
      ...newState
    }
  }

  componentDidMount () {
    if (this.state.action === 'update' || this.state.action === 'duplicate' || this.state.action === 'view') {
      this.getRubrique()
    }
  }

  getRubrique = async () => {
    const result = await ApiRequest(project.api + 'gestion', {
      requete: 'rubrique',
      action: 'get',
      id: this.state.id
    }, { showAlertError: false })
    if (result && result.code === 1) {
      const newState = {
        defaultLibelle: result.results.libelle && result.results.libelle.length > 0 && result.results.libelle[0].text,
        libelle: result.results.libelle,
        abrege: result.results.abrege,
        media_id: result.results.media_id,
        type: result.results.type,
        activite: result.results.activite,
        key: Utils.getRandomNumber()
      }
      this.setState({
        saveState: { action: 'view', ...EurestoClone(this.state.saveState), ...EurestoClone(newState) },
        ...newState,
        key: Utils.getRandomNumber()
      }, this.forceUpdate)
    }
  }

  onChangePicture = (file, base64) => {
    this.setState({
      media_libelle: file.name,
      media_base64: base64,
      media_type: file.type,
      picture: {
        media_lien: `data:${file.type};base64,`+base64
      }
    }, this.forceUpdate)
  }

  onChangeState = (e, name) => {
    this.setState({
      [name]: e
    }, this.forceUpdate)
  }

  onCancel = () => {
    this.setState({
      libelle: undefined,
      abrege: undefined,
      media_id: undefined,
      type: undefined,
      media_libelle: undefined,
      media_base64: undefined,
      media_type: undefined,
      activite: undefined,
      key: Utils.getRandomNumber(),
      action: 'add',
    }, () => this.props.onCancel())
  }

  onSave = async (action) => {
    const result = await ApiRequest(project.api + 'gestion', {
      requete: 'rubrique',
      action: action === 'update' ? 'update' : 'add',
      id: this.state.id,
      libelle: this.state.libelle,
      abrege: this.state.abrege,
      media_id: this.state.media_id,
      type: this.state.type,
      activite: this.state.activite,
    })
    if (result.code === 1) {
      this.onCancel()
    }
  }

  onDelete = async () => {
    const r = await ApiRequest(project.api + 'gestion', {
      requete: 'rubrique',
      action: 'delete',
      id: this.state.id,
    })
    if (r && r.code === 1) {
      this.setState({
        action: this.props.isAllow && (this.props.isAllow.add && 'add' || ' ')
      })
    }
  }

  onArchive = async () => {
    console.log('not done yet')
  }

  onView = (action) => {
    const newState = this.state.saveState
    newState.saveState = { ...EurestoClone(this.state.saveState) }
    newState.key = Utils.getRandomNumber()
    const keys = Object.keys(this.state)
    const stateReset = keys.reduce((acc, v) => ({ ...acc, [v]: undefined }), {})
    this.setState({
      ...stateReset,
      ...newState
    }, action === 'add' && this.props.onCancel(false) || this.forceUpdate)
  }

  form = (disabled, autoFocus) => {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="flex-start"
            alignItems="stretch">
        <DataComponent
          onChange={this.onChangePicture}
          name="picture"
          disabled={disabled}
          data={this.state.picture}
          type={Constants.typeSaisie.Picture}
          defineData={true}
          avatarStyle={{
            borderRadius: 10,
            border: '1px solid grey',
            maxWidth: 100,
            maxHeight: 100
          }} style={{
          height: 100
        }}
          object={{
            picture: this.state.picture || { id: undefined, lien: defaultAvatar },
            entite: this.state.entite,
            id: this.state.id
          }}/>
        <Traduction
          key={autoFocus}
          autoFocus={autoFocus}
          title={EurestoI18n.t('commun:Nom')}
          onChange={this.onChangeState}
          name={'libelle'}
          disabled={disabled}
          data={this.state.libelle !== undefined ? this.state.libelle : []}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <Traduction
          title={EurestoI18n.t('commun:Abrégé')}
          onChange={this.onChangeState}
          name={'abrege'}
          disabled={disabled}
          data={this.state.abrege !== undefined ? this.state.abrege : undefined}
          type={Constants.typeSaisie.SaisieLibre}
        />
        <Select
          title={EurestoI18n.t('commun:Type')}
          name="type"
          disabled={disabled}
          options={Constants.usefullObjectStatic[Constants.module.GESTION + '-' + Constants.donnee.rubrique].type.filter(o => o.condition ? o.condition() : true).map(o => ({
            label: o.libelle,
            value: o.id
          }))}
          value={this.state.type} onChange={this.onChangeState}/>
        <DataComponent
          title={EurestoI18n.t('commun:Activité')}
          name="activite"
          disabled={disabled}
          type={Constants.typeSaisie.ComboMulti}
          onChange={this.onChangeState}
          data={this.state.activite}
          object={Constants.donnee.activite}
          module={Constants.module.COMMUN}/>
      </Grid>
    )
  }

  render () {
    return (
      <EurestoForm key={this.state.key}
                   {...this.props.formProps}
                   libelle={this.state.defaultLibelle}
                   action={this.state.action}
                   isAllow={this.props.isAllow}
                   onSave={this.onSave}
                   onCancel={this.onCancel}
                   onDelete={this.onDelete}
                   onArchive={this.onArchive}
                   onView={this.onView}
                   libelleAdd={EurestoI18n.t('commun:Nouvelle rubrique')}
                   children={this.form}/>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataForm/Template/Gestion/Rubrique.js